import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeContext } from '../../../../ReportContext';
import useTheme from '../../hooks/useTheme';
import { appThemeSelector } from '../../../../../../components/App/AppSelectors';
import appThemes from '../../../../../../shared/style/themes/themes';

import BackCover from './templates/DefaultBackCover/BackCover';
import IProfileBackCover from './templates/IProfileBackCover/IProfileBackCover';

export default () => {
  const theme = useTheme(ThemeContext);
  const appTheme = useSelector(appThemeSelector);
  if (appTheme === appThemes.iprofile) {
    return <IProfileBackCover theme={theme} appTheme={appThemes.iprofile} />;
  }

  return <BackCover theme={theme} />;
};
